import { useGetDebtorsToConfirm } from 'api';
import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';
import { useHistory } from 'react-router';
import { IconName } from 'shared/components/Icon';
import { Button, Dropdown } from 'shared/io';

import styleIdentifiers from '../ClientsList.module.scss';

const styles = classNames.bind(styleIdentifiers);

type NoCheckBoxProps = {
  exportCSV: () => void;
  duplicatesCount: number;
};

/**
 *
 * @deprecated Do not use this component. Instead, learn to use tables.
 */
export const NoCheckBox = ({ exportCSV, duplicatesCount }: NoCheckBoxProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const { data: debtorsToConfirm } = useGetDebtorsToConfirm({ page_limit: 1 });
  const debtorsToConfirmCount = debtorsToConfirm?.metadata.pagination.total_objects ?? 0;

  const handleClickNewClient = () => history.push('/clients/new');

  const goToDuplicates = () => history.push('/clients/duplicates');

  return (
    <>
      <Dropdown
        className={styles('actions-dropdown')}
        toggleContent
        selectorContent={
          <Button
            className={styles('action')}
            noMargin
            label={t(i18nKeys.FORM.ACTIONS)}
            iconRight={IconName.ARROW_BOTTOM_ROUNDED}
          />
        }
      >
        <div className="dropdown-item" onClick={handleClickNewClient}>
          <div>{t(i18nKeys.NEW_CLIENT)}</div>
        </div>
        <div className="dropdown-item" onClick={exportCSV}>
          <div>{t(i18nKeys.EXPORT_CSV)}</div>
        </div>
      </Dropdown>
      {debtorsToConfirmCount > 0 && (
        <Button noMargin onClick={() => history.push('/clients/to-confirm')}>
          {t(i18nKeys.IMPORT_TO_CONFIRM)}
          <div className={styles('text-circle', 'absolute', 'border', 'blue')}>
            {debtorsToConfirmCount}
          </div>
        </Button>
      )}
      {duplicatesCount !== 0 && (
        <Button
          noMargin
          className={styles('button')}
          label={t(i18nKeys.DUPLICATES)}
          onClick={goToDuplicates}
        >
          <div className={styles('text-circle', 'absolute', 'border', 'blue')}>
            {duplicatesCount}
          </div>
        </Button>
      )}
      <Button
        noMargin
        className={styles('button')}
        label={t(i18nKeys.EXPORT)}
        onClick={exportCSV}
      />
      <Button
        noMargin
        className={styles('button')}
        label={t(i18nKeys.NEW_CLIENT)}
        onClick={() => history.push('/clients/new')}
      />
    </>
  );
};
